import { Component, computed, inject, input, signal } from "@angular/core"
import { Image } from "redlineLibs"
import {
  SvgGraphic,
  TimelineSvgGraphicsService,
} from "../../../pages/timeline/timeline.svg-graphics.service"
import { ImageCropperFormComponent } from "./image-cropper-form.component"
import { EditorService } from "../../../editor/services/editor.service"
import { UiTextareaComponent } from "ui-textarea"

@Component({
  imports: [
    ImageCropperFormComponent,
    UiTextareaComponent,
  ],
  standalone: true,
  template: `
    <div class="column">
      @if (showImageForm()) {
        <e2e-image-cropper-form
          [rowId]="rowId()"
        />
      }
      @if (imageExists()) {
        <div class="column">
          <div>
            Caption
          </div>
          <lib-ui-textarea
            [rows]="1"
            placeholder="caption"
            [value]="imageCaption()"
            (changes)="changeCaption($event)"
          />
          <div>
            Please describe the meaning of what you're uploading
          </div>
          <lib-ui-textarea
            [rows]="1"
            placeholder="alt text - required"
            [value]="imageAlt()"
            (changes)="changeAlt($event)"
          />
          <!--        <e2e-save-icon [modelChange]="imageAltModel()"/>-->
        </div>
        <div class="row-center">
          <button
            class="btn btn-sm btn-accent"
            (click)="removeImage()"
          >
            Remove Image
          </button>
        </div>
      }
    </div>
  `,
  selector: "e2e-image-edit",
})
export class ImageEditComponent {
  private editorService = inject(EditorService)
  private svgGraphicsService = inject(TimelineSvgGraphicsService)

  rowId = input.required<string>()

  showImageForm = signal(true)

  imageExists = computed(() => {
    // console.log(this.editorService.editorContent()?.rows)
    return !!(this.editorService.editorContent()?.rows[this.rowId()] as Image)?.filePath
  })
  imageField = computed(() =>
    this.editorService.editorContent()?.rows[this.rowId()] as Image | undefined
  )
  imageAlt = computed(() =>
    this.imageField()?.alt || ""
  )
  imageCaption = computed(() =>
    this.imageField()?.caption || ""
  )

  svgGraphics: SvgGraphic[] = this.svgGraphicsService.svgGraphics.map((svgGraphic) => ({
    ...svgGraphic,
    fileName: svgGraphic.fileName,
  }))
  imageAltModel = signal<number | undefined>(undefined)
  imageCaptionModel = signal<number | undefined>(undefined)

  changeAlt(alt: string) {
    this.imageAltModel.set(Date.now())
    const content = this.editorService.editorContent()
    const imageField = this.imageField()
    if (content && imageField) {
      this.editorService.queueEditor({
        ...content,
        rows: {
          ...content.rows,
          [this.rowId()]: {
            ...imageField,
            alt,
            // section: SectionEnum.IMAGE,
          },
        },
      })
    }
  }

  changeCaption(caption: string) {
    this.imageCaptionModel.set(Date.now())
    const content = this.editorService.editorContent()
    const imageField = this.imageField()
    if (content && imageField) {
      this.editorService.queueEditor({
        ...content,
        rows: {
          ...content.rows,
          [this.rowId()]: {
            ...imageField,
            caption,
            // section: SectionEnum.IMAGE,
          },
        },
      })
    }
  }

  removeImage() {
    const content = this.editorService.editorContent()
    if (content) {
      this.editorService.queueEditor({
        ...content,
        rows: {
          ...content.rows,
          [this.rowId()]: {
            ...content.rows[this.rowId()],
            alt: "",
            filePath: "",
            fileType: "",
          } as Image,
        },
      })
    }
    this.resetImageForm()
  }

  resetImageForm() {
    this.showImageForm.set(false)
    setTimeout(() => this.showImageForm.set(true), 0)
  }

}
